import { FC } from 'react';
import { IMember, IMemberChild } from '../../../models/members.model';
import styled from 'styled-components';
import { getCommonCodeLabel } from '../../../lib/store';
import i18n from '../../../lib/i18n';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Block = styled.div`
  th,
  td {
    text-align: center;
  }
`;

interface IProps {
  member?: IMember;
  memberChildrenInfo?: IMemberChild[];
}

const MemberChildrenInfo: FC<IProps> = ({ member, memberChildrenInfo }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const onMemberChildClick = (memberCode: string, campusCode: string) => {
    const params: any = {
      page: '1',
      memberCode: memberCode,
      campusCode: campusCode,
    };
    let uri = '/student/student';
    const qsParams = qs.stringify(params);
    qsParams ? (uri += `?${qsParams}`) : (uri += '?');
    history.push(`${uri}`);
  };

  return (
    <>
      {member?.memberType?.trim() === 'P' ? (
        <Block>
          <div className="comm-bx__space">
            <h3 className='sub-title'>{t('homepage.member.1')}</h3>
          </div>
          <div className='comm-table__area'>
            <table>
              <thead>
                <tr>
                  <th>{t('homepage.member.2')}</th>
                  <th>{t('homepage.member.3')}</th>
                  <th>{t('homepage.member.4')}</th>
                  <th>{t('homepage.member.5')}</th>
                </tr>
              </thead>
              <tbody>
                {memberChildrenInfo?.map((item) => (
                  <tr>
                    <td>
                      <span
                        className="mr-2 text-underline pointer"
                        onClick={() =>
                          onMemberChildClick(item.memberCode, item.campusCode)
                        }
                      >
                        {`${item.memberKorName}(${item.webId})`}
                      </span>
                    </td>
                    <td>{item.campusKorName}</td>
                    <td>{item.schoolKorName}</td>
                    <td>
                      {getCommonCodeLabel(
                        'SY0006',
                        item.gradeCode,
                        i18n.language,
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Block>
      ) : (
        ''
      )}
    </>
  );
};

export default MemberChildrenInfo;
